/* eslint-disable @typescript-eslint/no-explicit-any */
import { all, call, put, takeLatest } from 'redux-saga/effects';
import type { IMotoboyDedication } from '@/Interfaces/Data';

import Requests from '@/Services/Requests';
import {
  motoboyInfoFailure,
  motoboyInfoSuccess,
  motoboyDedicationRequest,
  motoboyDedicationSuccess,
  motoboyInfoRequest,
} from '.';

export function* setMotoboyById(action: any): any {
  try {
    const response: any = yield call(
      Requests.motoboys.getMotoboyId,
      action.payload,
    );

    if (response.r) {
      yield put(motoboyInfoSuccess(response.data));
    } else {
      yield put(motoboyInfoFailure([...response.errors]));
    }
  } catch (err: any) {
    const errorMessage = err.response?.data.error;
    yield put(motoboyInfoFailure([errorMessage]));
  }
}

export function* getMotoboyDedication(action: any): any {
  try {
    const response = yield call(
      Requests.motoboys.getDedications,
      action.payload,
    );

    if (!response.r) {
      yield put(motoboyInfoFailure([response.errors]));
      return;
    }

    yield put(
      motoboyDedicationSuccess({
        payload: response.data as IMotoboyDedication,
        motoboyId: action.payload,
      }),
    );
  } catch (err: any) {
    const errorMessage = err.response?.data.error;
    yield put(motoboyInfoFailure([errorMessage]));
  }
}

export default all([
  takeLatest(motoboyInfoRequest.type, setMotoboyById),
  takeLatest(motoboyDedicationRequest.type, getMotoboyDedication),
]);
